import { forwardRef } from 'react'
import { Body, Box } from '../widgets'
import { assetUrl } from '../../utilities.js'

export const GuidanceButton = forwardRef(function GuidanceButton({ onClick }, ref) {
  return (
    <Box
      ref={ref}
      container
      p="16px 32px"
      alignItems="center"
      rotate={3.5}
      r={16}
      border="1px solid white"
      background="var(--red)"
      shadow="2px 2px 0px 0px white"
      cursor="pointer"
      overflow="hidden"
      width={330}
      onClick={onClick}
    >
      <Body alt weight={600} lineHeight={1.22} maxWidth={160}>
        How to improve your results
      </Body>

      <Box
        position="absolute"
        right={-25}
        top={-33}
      >
        <img
          src={assetUrl('gifs/improve.gif')}
          alt="decoration"
          style={{width: 124}}
        />
      </Box>
    </Box>
  )
})